import { FormControl, TextField } from '@mui/material';
//constants
import { field } from '../types';
import { getErrorText } from '..';
import { CustomTextField } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import _ from 'lodash';
import { getFormattedAmountInputDisplayValue, getRawAmountInputValue } from 'utils';

type props = {
  valid: boolean;
  cField: field;
  initialValidation: any;
  handleChange: any;
};

export default function InputText(props: props) {
  const t = useAppSelector(selectTranslations);
  const { valid, cField, handleChange, initialValidation } = props;
  const { name, value, helperText, regex, formatAsAmount, ...textFieldProps } = cField.props;
  const displayValue = formatAsAmount
    ? getFormattedAmountInputDisplayValue(value)
    : ['null', 'undefined'].includes(typeof value) ? '' : value;

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    const nextValue = formatAsAmount ? getRawAmountInputValue(newValue) : newValue;
    const nextEvent = formatAsAmount
      ? {
          ...event,
          target: {
            ...event.target,
            name: event.target.name,
            value: nextValue,
          },
        }
      : event;

    if (regex) {
      regex.test(nextValue) && handleChange(nextEvent);
    } else {
      handleChange(nextEvent);
    }
  };

  const customErrorText = () => {
    const initialErrorText = getErrorText(initialValidation, name)
    let errorText = t(initialErrorText, initialErrorText)
    const validation = _.get(initialValidation, name)
    if (validation && validation?.errorValue) {
      errorText = errorText.replace('{0}', validation.errorValue)
    }
    return errorText
  }

  return (
    <CustomTextField key={name}>
      <FormControl error={!valid} fullWidth sx={cField.styleObj}>
        <TextField
          error={!valid}
          {...textFieldProps}
          name={name}
          helperText={valid ? helperText : customErrorText()}
          value={displayValue}
          onChange={handleInputChange}
          variant="filled"
          autoComplete="off"
        />
      </FormControl>
    </CustomTextField>
  );
}
